<div class="adc-modal" ngClass="{{ data.customClass }}" [ngClass]="toggle ? 'adc-d-block' : ''" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel">
    <div class="adc-modal-dialog">
        <div class="adc-modal-content">
        <div class="adc-modal-header" [ngClass]="data.titleAlignment === 'center' ? 'adc-justify-content-center' : 'adc-justify-content-start'">
            <h3 class="adc-modal-title" id="exampleModalLabel">{{data.modalTitle}}</h3>
            <!-- <mat-icon class="closeIcon" (click)="btnAction('Close')">close</mat-icon> -->
            <span class="material-symbols-outlined closeIcon" (click)="btnAction('Close')">close</span>
            <!-- <svg class="closeIcon" width="24px" (click)="btnAction('Close')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>close</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg> -->
        </div>
        <div class="adc-modal-body">
            <ng-content></ng-content>
        </div>
            <div class="adc-modal-footer" [ngClass]="data.buttonAlignment === 'center' ? 'adc-justify-content-center' : data.buttonAlignment === 'right' ? 'adc-justify-content-end' : 'adc-justify-content-start'">
                <ng-container *ngFor="let val of data.buttons">
                    <button type="button" class="adc-btn adc-btn-sm adc-btn-fixed" ngClass="{{ val.style }}" (click)="btnAction(val.name)">{{ val.name }} </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
